import { APIClient } from 'services/APIHttpClient'

const AuthSerivce = {
  loginUser({ username, password }) {
    return APIClient.post('/auth/signin', { username, password })

    // const url = `${process.env.REACT_APP_API_URL}/auth/signin`
    // console.log('sssss', url)
    // return fetch(`${process.env.REACT_APP_API_URL}/auth/signin`, {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json',
    //   },
    //   body: JSON.stringify({ username, password }),
    // }).then((data) => data.json())
  },
}

export default AuthSerivce
